import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { ArrowLeft } from "lucide-react";
import { useSelector } from "react-redux";
import PrevShiftChat from "../../component/past-shift/PrevShiftChat";
import ShiftInbox from "../../component/past-shift/shiftInbox";
import BaseUrl from "../../constants/BaseUrl";
import ParagraphTag from "../../component/reusebale/Paragraph";
import { hasValidLoginCredentials } from "../../utils/storageUtils";
import MyLoader from "../../component/reusebale/MyLoader";

const DetailShift = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { loginSuccess } = useSelector((state) => state.auth);

  const sessionIdPastShift = useSelector(
    (state) => state.data.sessionIdPastShift
  );
  const [chats, setChats] = useState([]);

  // Check authentication state on component mount
  useEffect(() => {
    const checkAuthState = () => {
      const hasValidLocalStorage = hasValidLoginCredentials();
      const hasReduxLoginData =
        loginSuccess !== null && loginSuccess !== undefined;

      if (!hasValidLocalStorage && !hasReduxLoginData) {
        console.log(
          "No valid authentication found in DetailShift, redirecting to login..."
        );
        navigate("/login", { replace: true });
        return;
      }
    };

    checkAuthState();
  }, [loginSuccess, navigate]);

  // ...existing code...

  const GetAllChats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getCompltedChatSessionsBySessionId/${sessionIdPastShift}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setChats(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetAllTechnicalChats = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/support/getTechnicalCompltedChatSessionsBySessionId/${sessionIdPastShift}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setChats(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    if (loginSuccess.user.type === "technical") {
      GetAllTechnicalChats();
    } else {
      GetAllChats();
    }
  }, [sessionIdPastShift]);

  const [selectedChatId, setSelectedChatId] = useState();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const { selectedSessionId } = useSelector((state) => state.data);

  // Early return if no valid authentication (after all hooks)
  const hasValidLocalStorage = hasValidLoginCredentials();
  const hasReduxLoginData = loginSuccess !== null && loginSuccess !== undefined;

  if (!hasValidLocalStorage && !hasReduxLoginData) {
    return (
      <div className="flex h-screen justify-center items-center">
        <MyLoader />
      </div>
    );
  }

  return (
    <div className="w-[95%] mx-auto h-screen flex flex-col justify-between">
      <div className="h-[15%] 2xl:h-[13%] flex items-center">
        <div className="flex justify-center items-center">
          <div
            className="flex justify-center items-center bg-white w-9 h-9 rounded-full cursor-pointer"
            onClick={() => navigate("/dashboard")}
          >
            <ArrowLeft className="text-themeColor" size={20} strokeWidth={2} />
          </div>
          <div className="ml-4">
            <ParagraphTag
              content={"Shift history"}
              classes="text-darkColor/40 font-popinsMedium text-xs "
            />
            <ParagraphTag
              content={"Support Staff"}
              classes={`text-darkColor font-popinsSemiBold text-xl text-darkColor font-popinsSemiBold text-lg mt-[-3px]`}
            />
          </div>
        </div>
      </div>
      <div className="h-[84%] 2xl:h-[86%] w-full flex flex-col justify-between">
        {/* <div className="h-[30%] flex justify-between">
          <div className="w-[60%]">
            <Info />
          </div>
          <div className="w-[38%]">
            <ShiftStatus />
          </div>
        </div> */}
        <div className="h-full flex">
          <div className="w-[25%] h-full">
            <PrevShiftChat
              chatId={selectedChatId}
              onChatSelect={(id) => {
                setSelectedChatId(id);
              }}
              chats={chats}
            />
          </div>
          <div className="w-[75%] pl-6 h-full overflow-scroll scrollbar-hide panelScroll">
            {selectedChatId ? (
              <ShiftInbox chatId={selectedChatId} />
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailShift;
